<template>
  <SurveyCardbase class="schedule-card-component">
    <template #header>
      <Avatar :picture="schedule.getPicture()" size="100px" />
      <section>
        <h4>{{ schedule.getExtraFirstname() }} {{ schedule.getExtraLastname() }}</h4>
        <p>{{ schedule.getQualification() }}</p>
      </section>
    </template>

    <template #main>
      <h4>{{ $filters.capitalizeFirstLetter(schedule.getDatesDisplay()) }}</h4>
      <section class="schedule-planned">
        <p>
          <span>{{ $t("ETAB.PAGES.REVIEW.EXTRA.@PLANNED_TITLE") }}</span>
          <span>{{ $t("ETAB.PAGES.REVIEW.EXTRA.@START_TO_END", { start: schedule.getPlannedStartTime(), end: schedule.getPlannedEndTime() }) }}</span>
          <span v-if="schedule.getPlannedBreakDuration()">
            {{ $t("ETAB.PAGES.REVIEW.EXTRA.@BREAK_DURATION", { break: schedule.getPlannedBreakDuration() }) }}
          </span>
        </p>

        <p v-if="schedule.getExtraStart() === null">
          <span>{{ $t("ETAB.PAGES.REVIEW.EXTRA.@EXTRA_TITLE", { name: schedule.getExtraFirstname() }) }}</span>
          <span>{{ $t("ETAB.PAGES.REVIEW.EXTRA.@WAITING") }}</span>
        </p>

        <p v-else class="text-primary">
          <span>{{ $t("ETAB.PAGES.REVIEW.EXTRA.@EXTRA_TITLE", { name: schedule.getExtraFirstname() }) }}</span>
          <span>{{ $t("ETAB.PAGES.REVIEW.EXTRA.@START_TO_END", { start: schedule.getExtraStart(), end: schedule.getExtraEnd() }) }}</span>
          <span v-if="schedule.getExtraBreakDuration()">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.REVIEW.EXTRA.@BREAK_DURATION", { break: schedule.getExtraBreakDuration() })) }}
          </span>
        </p>
      </section>
      <form>
        <Schedule
          :start-time="startTime"
          :end-time="endTime"
          :break-time-duration="breakDuration"
          :schedule-options="scheduleOptions"
          @select-start="selectStart"
          @select-end="selectEnd"
          @select-break-duration="selectBreakDuration"
          @on-error="onError"
        />
      </form>
    </template>

    <template #footer>
      <ExtraBtnIcon
        no-caps
        outline
        icon-name="icon-f-watch"
        color="primary-light"
        :btn-label="$t('ETAB.PAGES.REVIEW.EXTRA.@DECLARE_MISSING')"
        @click="onExtraMissing"
      />
      <ExtraBtnIcon
        no-caps
        :disable="!isValid"
        unelevated
        icon-name="icon-f-check-circle"
        color="primary"
        :icon-left="true"
        :btn-label="$t('ETAB.PAGES.REVIEW.EXTRA.@SAVE_SCHEDULE')"
        @click="saveSchedule"
      />
    </template>
  </SurveyCardbase>
</template>

<script>
  import { ScheduleHelpers } from "@core/helpers";
  import { ScheduleExtraModel } from "@core/models";
  import { ETAB_EVENTS } from "@etab/config";
  import { EventManager } from "@core/managers/event.manager";
  import Schedule from "@core/components/forms/Schedule.component.vue";
  import SurveyCardbase from "./SurveyCard.base.functional.vue";

  export default {
    components: {
      SurveyCardbase,
      Schedule,
    },
    props: {
      schedule: {
        type: Object,
        default: () => new ScheduleExtraModel(),
      },
    },
    data() {
      return {
        scheduleModified: false,
        isValid: true,
        scheduleOptions: undefined,
        startTime: undefined,
        endTime: undefined,
        breakDuration: undefined,
      };
    },
    created() {
      this.setScheduleOptions();
    },
    methods: {
      setScheduleOptions() {
        this.scheduleOptions = ScheduleHelpers.getFullScheduleOptions({
          stampText: this.$t("CORE.COMPONENTS.SCHEDULE.@DAY_PLUS_ONE"),
          nullBreakLabel: this.$t("CORE.COMPONENTS.SCHEDULE.@BREAK_NONE"),
        });

        this.startTime = this.schedule.getStartTime();
        this.endTime = this.schedule.getEndTime();
        this.breakDuration = this.schedule.getBreakDuration();
      },
      onError(value) {
        this.isValid = !value;
      },
      onExtraMissing() {
        EventManager.emit(ETAB_EVENTS.HOURLY_RECORD.DECLARE_MISSING, { schedule: this.schedule });
      },
      selectStart(value) {
        this.scheduleModified = true;
        this.startTime = value;
      },
      selectEnd(value) {
        this.scheduleModified = true;
        this.endTime = value;
      },
      selectBreakDuration(value) {
        this.scheduleModified = true;
        this.breakDuration = value;
      },
      saveSchedule() {
        if (this.scheduleModified && this.isValid) {
          this.schedule.setUpdatedSchedule({ start: this.startTime, end: this.endTime, breakDuration: this.breakDuration });
          EventManager.emit(ETAB_EVENTS.REVIEW.UPDATE_SCHEDULE, { schedule: this.schedule });
        } else {
          EventManager.emit(ETAB_EVENTS.REVIEW.CONFIRM_SCHEDULE, { schedule: this.schedule });
        }
      },
    },
  };
</script>

<style lang="scss">
  .schedule-card-component {
    > article > main {
      padding: 25px 15px 15px;
    }

    .schedule-planned {
      margin: 10px 0 0;
      font-size: 0.9em;
      line-height: 1.25;
      color: $primary-light;

      p {
        margin: 0;
      }
    }

    form {
      margin-top: 15px;
    }
  }
</style>
